const TET_RED = '#d32f2f';
const TET_GOLD = '#fbc02d';
const TET_GRADIENT = `linear-gradient(90deg, ${TET_RED}, ${TET_GOLD})`;
const SHOPIFY_GREEN = '#4caf50';

const isTet = (theme) => theme.colorScheme === 'tet';
const isShopify = (theme) => theme.colorScheme === 'shopify';

export const mantineComponents = {
    Button: {
        styles: (theme, params) => {
            if (!isTet(theme)) return {};
            const isFilledOrDefault = !params?.variant || params?.variant === 'filled';
            if (!isFilledOrDefault) return {};
            return {
                root: {
                    background: TET_GRADIENT,
                    border: 'none',
                    '&:not([disabled]):hover': {
                        background: TET_GRADIENT,
                        filter: 'brightness(0.92)',
                    },
                },
            };
        },
    },

    Checkbox: {
        styles: (theme) => {
            if (!isTet(theme)) return {};
            return {
                input: {
                    '&:checked': {
                        backgroundColor: `${TET_RED} !important`,
                        borderColor: `${TET_RED} !important`,
                    },
                },
            };
        },
    },

    Radio: {
        styles: (theme) => {
            if (!isTet(theme)) return {};
            return {
                radio: {
                    '&:checked': {
                        backgroundColor: `${TET_RED} !important`,
                        borderColor: `${TET_RED} !important`,
                    },
                },
            };
        },
    },

    Tabs: {
        styles: (theme) => {
            if (!isTet(theme) && !isShopify(theme)) return {};
            const activeColor = isShopify(theme) ? SHOPIFY_GREEN : TET_RED;
            return {
                tab: {
                    '&[data-active]': {
                        borderColor: `${activeColor} !important`,
                        color: `${activeColor} !important`,
                    },
                    '&[data-active]:hover': {
                        borderColor: `${activeColor} !important`,
                        color: `${activeColor} !important`,
                    },
                },
            };
        },
    },
    Switch: {
        styles: (theme) => {
            if (!isTet(theme) && !isShopify(theme)) return {};
            const activeColor = isShopify(theme) ? SHOPIFY_GREEN : TET_RED;
            return {
                input: {
                    '&:checked + *': {
                        backgroundColor: `${activeColor} !important`,
                        borderColor: `${activeColor} !important`,
                    },
                },
                track: {
                    'input:checked ~ &': {
                        backgroundColor: `${activeColor} !important`,
                        borderColor: `${activeColor} !important`,
                    },
                },
            };
        },
    },
    Select: {
        styles: (theme) => {
            if (!isTet(theme)) return {};
            return {
                input: {
                    '&:focus': {
                        borderColor: `${TET_RED} !important`,
                    },
                },
                item: {
                    '&[data-selected]': {
                        backgroundColor: `${TET_RED} !important`,
                        color: 'white !important',
                    },
                },
            };
        },
    },
};
